// ============================================================
// School Store (Zustand)
// ============================================================
// Multi-school context: Owner can switch between schools,
// other roles have a single assigned school.

import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import config from '@/config';
import useAuthStore from '@/store/authStore';

const useSchoolStore = create(
  persist(
    (set) => ({
      // ── State ────────────────────────────────────
      currentSchool: null,
      schools: [],

      // ── Actions ──────────────────────────────────
      setCurrentSchool: (school) => {
        set({ currentSchool: school });
        const user = useAuthStore.getState().user;
        const roleUpper = String(user?.role || '').toUpperCase();
        if (roleUpper === 'ORGANIZATION_ADMIN') {
          const rawMods = school?.school_modules || school?.modules || [];
          const mods =
            Array.isArray(rawMods) && rawMods.length > 0
              ? rawMods.map((sm) => sm.module || sm)
              : [];
          useAuthStore.getState().setModules(mods);
        }
      },

      setSchools: (schools) => set({ schools }),

      switchSchool: (schoolId) =>
        set((state) => {
          const school = state.schools.find((s) => s.id === schoolId);
          if (school) {
            const user = useAuthStore.getState().user;
            const roleUpper = String(user?.role || '').toUpperCase();
            if (roleUpper === 'ORGANIZATION_ADMIN') {
              const rawMods = school?.school_modules || school?.modules || [];
              const mods =
                Array.isArray(rawMods) && rawMods.length > 0
                  ? rawMods.map((sm) => sm.module || sm)
                  : [];
              useAuthStore.getState().setModules(mods);
            }
            return { currentSchool: school };
          }
          return {};
        }),

      clearSchoolData: () => set({ currentSchool: null, schools: [] }),
    }),
    {
      name: config.storage.schoolKey,
      partialize: (state) => ({
        currentSchool: state.currentSchool,
      }),
    }
  )
);

export default useSchoolStore;
